// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#message-detail-subheader-left {
  display: flex;
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
}
#message-detail-subheader-left div:first-child {
  font-size: x-large;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--boxx-app-lightgray, #dedede);
}
#message-detail-subheader-left div:first-child ion-icon {
  width: 16px;
  height: 16px;
  color: var(--ion-color-secondary);
}
#message-detail-subheader-left div:last-child {
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  margin: auto;
}

#message-detail-subheader-right {
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: 16px;
  color: var(--ion-text-color);
  font-size: 14px;
  font-weight: 600;
}
#message-detail-subheader-right #sender-phone {
  display: flex;
  align-items: center;
}
#message-detail-subheader-right #sender-phone a {
  color: var(--ion-text-color);
}
#message-detail-subheader-right #sender-phone ion-img {
  width: 32px;
  margin-right: 4px;
}
#message-detail-subheader-right #sender-phone ion-icon {
  color: var(--ion-color-medium);
  width: 24px;
  height: 24px;
}

ion-card.boxx-card {
  margin-top: 16px;
  padding: 16px;
}
ion-card.boxx-card .source-icon ion-icon {
  width: 16px;
  height: 16px;
}

.top-row {
  display: flex;
  justify-content: space-between;
}
.top-row .conversation-date {
  font-size: 12px;
  font-weight: 500;
  color: var(--ion-color-medium);
}

.lead-body {
  margin-top: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ion-text-color);
}

.lead-actions {
  margin-top: 24px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: var(--ion-text-color);
}
.lead-actions ion-icon {
  width: 18px;
  height: 13px;
}

@media screen and (min-width: 960px) {
  ion-card.boxx-card {
    max-width: 75%;
    min-width: 310px;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/messages-core/lib/components/lead-item-open/lead-item-open.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,iCAAA;AACN;AAGE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AADJ;;AAKA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AAFF;AAGE;EACE,aAAA;EACA,mBAAA;AADJ;AAEI;EACE,4BAAA;AAAN;AAGI;EACE,WAAA;EACA,iBAAA;AADN;AAGI;EACE,8BAAA;EACA,WAAA;EACA,YAAA;AADN;;AAMA;EACE,gBAAA;EACA,aAAA;AAHF;AAIE;EACE,WAAA;EACA,YAAA;AAFJ;;AAMA;EACE,aAAA;EACA,8BAAA;AAHF;AAIE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAFJ;;AAMA;EACE,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AAHF;;AAMA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AAHF;AAIE;EACE,WAAA;EACA,YAAA;AAFJ;;AAMA;EACE;IACE,cAAA;IACA,gBAAA;EAHF;AACF","sourcesContent":["#message-detail-subheader-left {\n  display: flex;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 500;\n\n  div:first-child {\n    font-size: x-large;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    margin-right: 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: var(--boxx-app-lightgray, #dedede);\n\n    ion-icon {\n      width: 16px;\n      height: 16px;\n      color: var(--ion-color-secondary);\n    }\n  }\n\n  div:last-child {\n    line-height: 1.2;\n    display: flex;\n    flex-direction: column;\n    margin: auto;\n  }\n}\n\n#message-detail-subheader-right {\n  line-height: 1.2;\n  display: flex;\n  flex-direction: column;\n  margin-left: auto;\n  margin-right: 16px;\n  color: var(--ion-text-color);\n  font-size: 14px;\n  font-weight: 600;\n  #sender-phone {\n    display: flex;\n    align-items: center;\n    a {\n      color: var(--ion-text-color);\n    }\n\n    ion-img {\n      width: 32px;\n      margin-right: 4px;\n    }\n    ion-icon {\n      color: var(--ion-color-medium);\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\nion-card.boxx-card {\n  margin-top: 16px;\n  padding: 16px;\n  .source-icon ion-icon {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.top-row {\n  display: flex;\n  justify-content: space-between;\n  .conversation-date {\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--ion-color-medium);\n  }\n}\n\n.lead-body {\n  margin-top: 8px;\n  margin-bottom: 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ion-text-color);\n}\n\n.lead-actions {\n  margin-top: 24px;\n  text-align: right;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ion-text-color);\n  ion-icon {\n    width: 18px;\n    height: 13px;\n  }\n}\n\n@media screen and (min-width: 960px) {\n  ion-card.boxx-card {\n    max-width: 75%;\n    min-width: 310px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
